<template>
  <div class="procurement-revamp procurement-revamp--modern oms-list-page oms-list-page--procurement oms-list-page--compact-table">
    <SelectCountry
      :open="selectCountryDialog"
      @closeSelectCountry="selectCountryDialog = false"
      :type="'/procurement/new'"
    />
    <v-card class="procurement-panel oms-list-panel">
      <section class="procurement-nav-grid oms-list-nav">
        <SegmentedControl
          class="main__tabs procurement-primary-tabs"
          aria-label="Procurement view"
          :value="tabStatusMain"
          :options="[
            { label: 'Job View', value: 'Jobs', icon: 'work_outline' },
            {
              label: 'Assignment View',
              value: 'Assignment',
              icon: 'assignment',
            },
          ]"
          @change="redirectTo"
        />

        <SegmentedControl
          class="procurement-status-tabs"
          aria-label="Procurement job status"
          :value="tabStatus"
          :options="[
            {
              label: 'Unassigned Jobs',
              value: 'Unassigned',
              badge: newUnassigned,
            },
            {
              label: 'In Progress Jobs',
              value: 'In-progress',
              badge: newInprogress,
            },
            {
              label: 'Completed Jobs',
              value: 'Completed',
              badge: newCompleted,
            },
          ]"
          @change="searchData($event, null)"
        />
      </section>

      <section class="procurement-stats-grid oms-list-stats">
        <article class="procurement-stat-card procurement-stat-card--inquiry oms-list-stat-card">
          <div class="procurement-stat-icon"><v-icon>receipt</v-icon></div>
          <span>Inquiry Queue</span>
          <strong>{{ totalInquiry || "0" }}</strong>
          <small>Pending review</small>
        </article>

        <article class="procurement-stat-card procurement-stat-card--finding oms-list-stat-card">
          <div class="procurement-stat-icon"><v-icon>search</v-icon></div>
          <span>Finding Drivers</span>
          <strong>{{ totalFindingDrivers || "0" }}</strong>
          <small>Open sourcing</small>
        </article>

        <article class="procurement-stat-card procurement-stat-card--assigned oms-list-stat-card">
          <div class="procurement-stat-icon">
            <v-icon>assignment_ind</v-icon>
          </div>
          <span>Driver Assigned</span>
          <strong>{{ totalDriverAssigned || "0" }}</strong>
          <small>Ready lanes</small>
        </article>

        <article class="procurement-stat-card procurement-stat-card--total oms-list-stat-card">
          <div class="procurement-stat-icon"><v-icon>dashboard</v-icon></div>
          <span>Total Jobs</span>
          <strong>{{ totalJob || "0" }}</strong>
          <small>Current view</small>
        </article>

        <StatCard
          v-permissions="'add-new-jobs'"
          class="oms-page-action-card procurement-add-job-card"
          actionable
          label="Add Job"
          value="New"
          caption="Create procurement job"
          icon="add"
          variant="primary"
          @click="checkAddJob()"
        />
      </section>

      <FilterBoard
        class="procurement-filter-panel oms-list-filter"
        :title="`${tabStatus} procurement queue`"
      >
          <v-flex xs2 md3 class="procurement-filter-field oms-filter-board__field">
            <v-select
              v-model="searchTypes"
              :items="searchItems"
              flat
              label="Search Type"
              item-text="status"
              single-line
              class="pt-0 currencyTitle pppp"
              item-value="abbr"
              persistent-hint
              @change="searchData()"
              height="2.625rem"
              return-object
              outline
            ></v-select>
          </v-flex>
          <v-flex
            xs2
            md3
            pr-3
            class="procurement-filter-field oms-filter-board__field oms-filter-board__field--search"
          >
            <v-text-field
              height="2.5rem"
              class="gap Bottom_2px"
              label="Search here.."
              outline
              :disabled="!searchTypes"
              single-line
              v-model="search"
              @keyup.enter="searchData()"
              @click:append="searchData()"
              append-icon="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 md3 class="procurement-filter-field oms-filter-board__field">
            <v-select
              v-model="driverSearchTypes"
              :items="driverSearchItems"
              flat
              label="Search  Type"
              item-text="status"
              single-line
              class="pt-0 currencyTitle pppp"
              item-value="abbr"
              persistent-hint
              @change="searchData()"
              height="2.625rem"
              return-object
              outline
            ></v-select>
          </v-flex>
          <v-flex
            xs2
            md3
            pr-3
            class="procurement-filter-field oms-filter-board__field oms-filter-board__field--search"
          >
            <v-text-field
              height="2.5rem"
              class="gap Bottom_2px"
              label="Search here.."
              outline
              :disabled="!driverSearchTypes"
              single-line
              v-model="driverSearch"
              @keyup.enter="searchData()"
              @click:append="searchData()"
              append-icon="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pr-1 class="procurement-filter-field oms-filter-board__field">
            <v-select
              v-model="subJobType"
              :items="JobListTypes"
              label="Job Type"
              persistent-hint
              return-object
              @change="searchData()"
              single-line
            ></v-select>
          </v-flex>
          <v-flex
            xs3
            pl-3
            id="jobDate"
            class="wrapper procurement-filter-date oms-filter-board__field oms-filter-board__field--date"
          >
            <ejs-daterangepicker
              :placeholder="waterMark"
              v-model="dateRange2"
            ></ejs-daterangepicker>
          </v-flex>

          <v-flex xs1 class="reset-btn procurement-filter-actions oms-filter-board__actions">
            <v-card-actions class="justify-center">
              <v-btn
                flat
                class="reset-btn-color procurement-reset-link oms-filter-board__reset oms-btn oms-btn--secondary"
                prepend-icon
                color="orange darken-1"
                @click.native="reset()"
              >
                Reset
                <v-icon color="orange">donut_large</v-icon>
              </v-btn>
            </v-card-actions>
          </v-flex>
      </FilterBoard>
      <v-card-text class="nospace procurement-table-card oms-list-table-card">
        <ScrollableTable class="procurement-table-scroll oms-list-table-scroll" min-width="var(--oms-list-table-min-width, 116rem)">
          <v-data-table
            id="jobsTable"
            class="procurement-table oms-list-table"
            hide-actions
            :headers="headers"
            :disable-initial-sort="true"
            :pagination.sync="pagination"
            :items="items"
          >
          <template slot="items" slot-scope="props">
            <tr
              :key="props.index"
              :class="[
                getDates(props.item.startDate, props.item.pickupTime) <= 12 &&
                getDates(props.item.startDate, props.item.pickupTime) > 6 &&
                (props.item.jobStatus === 3 || props.item.jobStatus === 4)
                  ? 'colorchangeyellow'
                  : '',
                getDates(props.item.startDate, props.item.pickupTime) <= 6 &&
                (props.item.jobStatus === 3 || props.item.jobStatus === 4)
                  ? 'colorchange'
                  : '',
              ]"
            >
              <td class="procurement-job-cell">
                <div class="procurement-job-id-row">
                  <activityLogs
                    :permissions="'activity-logs-jobs'"
                    :type="'jobs'"
                    :_id="props.item._id"
                    :id="props.item.jobId.toString()"
                  />
                  <span
                    class="procurement-job-id"
                    :title="props.item.jobId.toString()"
                  >
                    {{ props.item.jobId }}
                  </span>
                </div>
              </td>
              <td class="procurement-country-cell">
                <div class="procurement-country-stack">
                  <img
                    v-if="props.item.workingCountry == 'PAK'"
                    src="../../assets/pakflag.png"
                    height="20px"
                  /><img
                    v-if="props.item.workingCountry == 'KSA'"
                    src="../../assets/ksaflag.png"
                    height="20px"
                  /><img
                    v-if="props.item.workingCountry == 'UAE'"
                    src="../../assets/Uaeflag.png"
                    height="20px"
                  /><img
                    v-if="props.item.workingCountry == 'UAE LA'"
                    src="../../assets/Uaeflag.png"
                    height="20px"
                    style="border-radius: 50%"
                  />
                  <img
                    v-if="props.item.workingCountry == 'OMAN'"
                    src="../../assets/omanflag.png"
                    height="28px"
                  /><span>{{ props.item.workingCountry || "-" }}</span>
                </div>
              </td>

              <td class="procurement-company-cell" v-if="props.item.customer">
                {{ props.item.companyName || props.item.customer }}
              </td>
              <td class="procurement-company-cell" v-else>
                {{ props.item.customerEmail || "-" }}
              </td>
              <td class="procurement-date-cell">
                {{ getTime3(props.item.pickupDate) }}
                {{ props.item.pickUpTime }}
              </td>
              <td class="procurement-route-cell procurement-route-cell--combined">
                <div class="procurement-route-pair">
                  <v-tooltip
                    right
                    class="milestone"
                    content-class="tooltip-op"
                    color="orange"
                  >
                    <template slot="activator">
                      <div class="procurement-route-point procurement-route-point--from">
                        <span>From</span>
                        <strong>
                          {{ props.item.sourceCity }},
                          {{ props.item.sourceCountry }}
                        </strong>
                      </div>
                    </template>
                    <span class="tooltip">{{ props.item.sourceLocation }}</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    class="milestone"
                    content-class="tooltip-op"
                    color="orange"
                  >
                    <template slot="activator">
                      <div class="procurement-route-point procurement-route-point--to">
                        <span>To</span>
                        <strong>
                          {{ props.item.destinationCity }},
                          {{ props.item.destinationCountry }}
                        </strong>
                      </div>
                    </template>
                    <span class="tooltip">{{
                      props.item.destinationLocation
                    }}</span>
                  </v-tooltip>
                </div>
              </td>
              <td class="procurement-price-cell" v-if="props.item.jobPrice">
                <span class="procurement-price-value">
                  {{ props.item.jobPrice }} {{ props.item.customerCurrency }}
                </span>
              </td>
              <td class="procurement-price-cell procurement-price-cell--empty" v-else>
                N.A.
              </td>
              <td class="procurement-assignment-cell" v-if="props.item.jobStatus == 6">
                <span class="procurement-assignment-count">
                  {{ props.item.transit }}/{{
                    props.item.numberOfAssignmentsRequired
                  }}
                </span>
                <br />
                <Assignments
                  v-permissions="'activity-logs-jobs'"
                  :jobId="props.item.jobId"
                />
              </td>
              <td
                class="procurement-assignment-cell"
                v-else-if="props.item.jobStatus == 7"
              >
                <span class="procurement-assignment-count">
                  {{ props.item.shipment }}/{{
                    props.item.numberOfAssignmentsRequired
                  }}
                </span>
                <br />
                <Assignments
                  v-permissions="'activity-logs-jobs'"
                  :jobId="props.item.jobId"
                />
              </td>
              <td
                class="procurement-assignment-cell"
                v-else-if="props.item.jobStatus == 8"
              >
                <span class="procurement-assignment-count">
                  {{ props.item.paymentPending }}/{{
                    props.item.numberOfAssignmentsRequired
                  }}
                </span>
                <br />

                <Assignments
                  v-permissions="'activity-logs-jobs'"
                  :jobId="props.item.jobId"
                />
              </td>
              <td
                class="procurement-assignment-cell"
                v-else-if="props.item.jobStatus == 9"
              >
                <span class="procurement-assignment-count">
                  {{ props.item.paymentDone }}/{{
                    props.item.numberOfAssignmentsRequired
                  }}
                </span>
                <br />
                <Assignments
                  v-permissions="'activity-logs-jobs'"
                  :jobId="props.item.jobId"
                />
              </td>
              <td
                class="procurement-assignment-cell"
                v-else-if="
                  props.item.jobStatus == 5 ||
                  props.item.jobStatus == 4 ||
                  props.item.jobStatus == 1
                "
              >
                <span class="procurement-assignment-count">
                  {{ props.item.Assigned }}/{{
                    props.item.numberOfAssignmentsRequired
                  }}
                </span>
                <br />
                <Assignments
                  v-permissions="'activity-logs-jobs'"
                  :jobId="props.item.jobId"
                />
              </td>
              <td class="procurement-assignment-cell" v-else>
                <Assignments
                  v-permissions="'activity-logs-jobs'"
                  :jobId="props.item.jobId"
                />
              </td>

              <td class="procurement-status-cell">
                <span
                  class="procurement-status-pill"
                  :class="{
                    'procurement-status-pill--open':
                      props.item.jobStatus === 1 ||
                      props.item.jobStatus === 3 ||
                      props.item.jobStatus === 4,
                    'procurement-status-pill--moving':
                      props.item.jobStatus === 5 ||
                      props.item.jobStatus === 6 ||
                      props.item.jobStatus === 7,
                    'procurement-status-pill--pending':
                      props.item.jobStatus === 8 ||
                      props.item.jobStatus === 10,
                    'procurement-status-pill--done':
                      props.item.jobStatus === 9 ||
                      props.item.jobStatus === 2,
                    'procurement-status-pill--cancelled':
                      props.item.jobStatus === -1
                  }"
                >
                  {{ jobsStatus(props.item.jobStatus) }}
                </span>
                <span class="procurement-exec-name">
                  {{
                    props.item.isAcknowedged && props.item.procurementExec
                      ? props.item.procurementExec.name
                      : ""
                  }}
                </span>
              </td>

              <td class="procurement-action-cell">
                <button
                  v-permissions="'view-details-jobs'"
                  v-if="!props.item.isAcknowedged && props.item.jobStatus != -1"
                  @click="
                    open(props.item, props.index, props.item.workingCountry)
                  "
                  target="_blank"
                  :disabled="props.item.jobStatus == 10"
                  class="assign-driver-btn oms-btn oms-btn--primary"
                  title="Acknowledge Inquiry"
                >
                  Acknowledge
                </button>
                <button
                  v-if="props.item.jobStatus != -1 && props.item.isAcknowedged"
                  v-permissions="'view-details-jobs'"
                  @click="check(props.item.jobId)"
                  :disabled="loading"
                  target="_blank"
                  class="track-ass-btn oms-btn oms-btn--primary"
                >
                  Details
                </button>
                <br />
                <button
                  v-if="props.item.jobStatus != -1 && props.item.isAcknowedged"
                  v-permissions="'view-details-jobs'"
                  @click="open2(props.item, props.index)"
                  target="_blank"
                  class="cancel-btn oms-btn oms-btn--destructive"
                >
                  Cancel
                </button>
              </td>
              <td class="procurement-vendor-cell">
                <span
                  v-if="
                    props.item.isTransporterJob &&
                    (props.item.jobStatus != -1 || props.item.jobStatus != 2) &&
                    props.item.isAcknowedged
                  "
                  >{{ props.item.jobModel }}</span
                >

                <Bidpopup
                  v-if="
                    props.item.jobPrice &&
                    !props.item.isDriverJob &&
                    !props.item.isTransporterJob &&
                    props.item.jobStatus != -1 &&
                    (props.item.jobStatus == 3 || props.item.jobStatus == 4) &&
                    props.item.isAcknowedged &&
                    isOnlyLand(props.item.jobType)
                  "
                  :address="props.item"
                  @error="
                    x.error =
                      'Job has already started, you cannot send a bid for this job'
                  "
                  v-on:transport-job="bidSuccess"
                  v-on:bid-success="refreshBid"
                />
                <v-spacer></v-spacer>
                <Responsepopup
                  :bid="props.item"
                  v-if="
                    props.item.isTransporterJob &&
                    props.item.jobStatus != -1 &&
                    props.item.jobStatus != 2 &&
                    props.item.isAcknowedged
                  "
                  v-on:response-job="refreshBid"
                />
                <ResponseForDriver
                  :bidD="props.item"
                  v-if="
                    props.item.isDriverJob &&
                    props.item.jobStatus != -1 &&
                    props.item.jobStatus != 2 &&
                    props.item.isAcknowedged
                  "
                  v-on:response-jobD="refreshBid"
                />
              </td>
              <td class="procurement-comment-cell">
                <span
                  v-if="getLatestCommentTime(props.item.LastCommentTime)"
                  class="procurement-comment-time"
                >
                  {{ getLatestCommentTime(props.item.LastCommentTime) }}
                </span>
                <CommentCell
                  :comment="
                    props.item.LastCommentTime &&
                    props.item.LastCommentTime.comment
                  "
                >
                  <template slot="action">
                    <SendComments
                      class="oms-comment-cell__action procurement-comment-action"
                      compact-action
                      :userId="props.item.userId"
                      :userName="props.item.customer"
                      :detail="props.item"
                      :type="2"
                      :id="props.item.jobId"
                      v-on:pagination-load="refreshOnComment"
                    />
                  </template>
                </CommentCell>
              </td>
            </tr>
          </template>
          <v-alert
            slot="no-results"
            :value="isNoSearchResult"
            color="blue"
            icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
          </v-data-table>
        </ScrollableTable>

        <pagination
          :totalPages="totalPages"
          :pages="this.pages"
          @pageNo="page"
          :type="0"
          :componentKey="componentKey"
          :loading="paginationLoading"
          :url="paginationURL"
          :callback="callback"
          :action="`procure`"
          v-on:pagination-load="checkLoading"
        />
      </v-card-text>
      <v-snackbar
        :timeout="3000"
        color="red darken-2"
        v-model="x.error"
        class="white--text"
        v-if="x.error"
        >{{ x.error }}</v-snackbar
      >
      <v-dialog
        v-model="dialog"
        persistent
        :max-width="options.width"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
      >
        <loading :active.sync="loading" />

        <v-card>
          <v-toolbar dark :color="options.color" dense flat>
            <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
          </v-toolbar>

          <v-card-text v-show="!!message" class="pa-4">
            {{ message }}
            <!-- <v-text-field
              type="text"
              label="Please add comments here"
              required
              v-model="statusComments"
              :value="statusComments"
            /> -->
            <!-- {{ userNameList }} -->
            <v-autocomplete
              :items="userNameList"
              item-text="name"
              v-model="selectedUserId"
              label="select the name of admin who procured this job"
              item-value="_id"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions class="pt-0 pr-4">
            <v-spacer />
            <v-btn
              color="primary darken-1"
              :disabled="loading"
              text
              @click.native="agree"
              >Yes</v-btn
            >
            <v-btn color="grey" text @click.native="cancel">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- CANCEL CONFIRMATION -->
      <v-dialog
        v-model="dialog2"
        persistent
        :max-width="options.width"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-toolbar dark :color="options.color" dense flat>
            <v-toolbar-title class="white--text">{{
              cancelTitle
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text v-show="!!cancelMessage" class="pa-4">
            {{ cancelMessage }}
            <div
              v-if="showAdvanceWarning"
              class="advance-warning"
              style="
                color: red;
                font-weight: bold;
                margin-top: 10px;
                margin-bottom: 10px;
              "
            >
              Advance already paid for amount ({{ advancePaidAmount }}
              {{ advanceCurrency }}). Are you sure you want to cancel this job?
            </div>
            <v-flex pt-2 pr-1>
              <div class="subheading muted caption">
                Provide cancellation reason
              </div>
              <v-select
                class="pt-0 currencyTitle"
                v-model="cancelType"
                :items="cancellationType"
                :menu-props="{ offsetY: true }"
                label="Select your option"
                persistent-hint
                return-object
                single-line
              ></v-select>
            </v-flex>
            <v-flex>
              <div
                v-if="cancelType.value == 'Other’s'"
                class="subheading muted caption"
              >
                Reason
              </div>
              <v-text-field
                class="pt-0 currencyTitle"
                v-if="cancelType.value == 'Other’s'"
                type="text"
                single-line
                label="Enter your reason"
                required
                v-model="cancelComments"
                :value="cancelComments"
              />
            </v-flex>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn color="primary darken-1" text @click.native="open3"
              >Yes</v-btn
            >
            <v-btn color="grey" text @click.native="cancel2">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog3"
        persistent
        :max-width="450"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-toolbar
            dark
            flat
            style="background-color: #fee9d0; color: black; padding-left: 100px"
          >
            <v-toolbar-title dark>{{ cancelTitle1 }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon
                class="heading grey--text text--darken-4"
                @click.prevent="dialog3 = false"
                >close</v-icon
              >
            </v-btn>
          </v-toolbar>
          <v-spacer class="spacerclass">
            <v-card-text
              style="text-align: center"
              v-show="!!cancelMessage1"
              class="pa-4"
            >
              <div class="pb-4">
                <img
                  src="../../assets/Character-sitting.png"
                  height="300"
                  width="300"
                />
              </div>
              <div class="subheading">{{ cancelMessage1 }}</div>

              <div
                v-if="cancelType.value == 'Other’s'"
                class="subheading muted pt-2"
              >
                <span style="color: darkgrey">Cancellation reason:</span>
                <p style="word-break: break-all">
                  {{ cancelType.value }} - {{ cancelComments }}
                </p>
              </div>
              <div v-else class="subheading muted pt-2">
                <span style="color: darkgrey">Cancellation reason:</span>
                {{ cancelType.value }}
              </div>
            </v-card-text>

            <v-card-actions class="pt-0 pb-5" style="justify-content: center">
              <v-btn
                medium
                style="text-transform: none !important"
                color="orange white--text"
                darken-1
                text
                :loading="loading"
                @click.native="agree2"
                >DONE</v-btn
              >
            </v-card-actions>
          </v-spacer>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Vue from "vue";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import SendComments from "@/components/Pop-ups/SendComments";
import CommentCell from "@/components/Common/CommentCell";

Vue.use(DateRangePickerPlugin);
//import DateRangePicker from "vue2-daterange-picker";
import activityLogs from "../Common/activityLogs";
//you need to import the CSS manually (in case you want to override it)
//import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { EventBus } from "../../event-bus.js";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
import Bidpopup from "./Bidpopup";
import Responsepopup from "./Responsepopup";

import ResponseForDriver from "./ResponseForDriver";
let momentTz = require("moment-timezone");
import JobsProfile from "@/components/Jobs/JobDetails/JobsProfile";
import DriverProfileForm from "@/components/Drivers/DriverProfileForm";
import PaginationButtons from "@/components/Pagination/PaginationButtons";
import pagination from "@/components/Pagination/pagination";
import Assignments from "./Assignments";
import {
  StorageKeys,
  JobListTypes,
  CancellationType,
} from "../../constants/constants";
import ErrorBox from "@/components/Common/ErrorBox";
import SelectCountry from "../Common/SelectCountry";
import FilterBoard from "@/components/Common/FilterBoard";
import ScrollableTable from "@/components/Common/ScrollableTable";
import SegmentedControl from "@/components/Common/SegmentedControl";
import StatCard from "@/components/Common/StatCard";
import { procurementList } from "@/constants/datatable-headers.js";
import { async } from "q";
import { newjobList } from "../../constants/api-urls";
export default {
  created() {
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = JSON.stringify(workingCountry);
      this.identify(localStorage.getItem("email"));
      this.track("Procurement Section", {
        email: localStorage.getItem("email"),
        name: localStorage.getItem("user"),
        "Working Country": workingCountry.toString(),
      });
    }

    EventBus.$on("countryChanged", (val) => {
      if (this.$route.name == "procurement") {
        this.workingCountry = JSON.stringify(val);
        if (localStorage.getItem("paginationUrlProcure") !== null) {
          this.updatePaginationUrl();
        } else {
          this.paginationURL = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&isSearch=true&status=${this.tabStatus}`;
          this.getJobListCount();
        }
      }
    });
    EventBus.$on("unassignedJob-notification", (val) => {
      this.newUnassigned = this.newUnassigned + 1;
    });
    EventBus.$on("assignedDriver-notification", (val) => {
      this.newInprogress = this.newInprogress + 1;
    });
    EventBus.$on("completeAssignment-notification", (val) => {
      this.newCompleted = this.newCompleted + 1;
    });
    this.JobListTypes = JobListTypes;
    this.cancellationType = CancellationType;
    if (localStorage.getItem("paginationUrlProcure") !== null) {
      this.updatePaginationUrl();
    } else {
      this.paginationURL = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&isSearch=true&status=${this.tabStatus}`;
      this.getJobListCount();
    }
    if (localStorage.getItem("subJobTypePro")) {
      this.subJobType = JSON.parse(localStorage.subJobTypePro);

      this.loading = false;
    }
    if (localStorage.getItem("searchProcurement") !== null) {
      this.search = localStorage.searchProcurement;
      this.searchTypes = JSON.parse(localStorage.searchProcurementType);
    }
    if (localStorage.getItem("searchProcurementDriver") !== null) {
      this.driverSearch = localStorage.searchProcurementDriver;
      this.driverSearchTypes = JSON.parse(
        localStorage.searchProcurementDriverType
      );
    }

    if (localStorage.getItem("ProtartdateFilter") !== null) {
      this.dateRange2 = JSON.parse(localStorage.ProtartdateFilter);
    }

    this.$eventBus.$on("close-job-profile", () => {
      this.dialog = false;
      this.currentItem = null;
    });
  },

  mounted() {
    if (localStorage.getItem("TabStatus") != null) {
      this.tabStatus = localStorage.getItem("TabStatus").toString();
      this.searchData(this.tabStatus, null);
    } else {
      this.tabStatus = "Unassigned";
      this.searchData(this.tabStatus, null);
    }
  },

  components: {
    FilterBoard,
    CommentCell,
    ScrollableTable,
    SegmentedControl,
    StatCard,
    DriverProfileForm,
    ResponseForDriver,
    pagination,
    //DateRangePicker,
    JobsProfile,
    SendComments,
    PaginationButtons,
    Assignments,
    activityLogs,
    ErrorBox,
    Responsepopup,
    Bidpopup,
    SelectCountry,
  },
  data() {
    return {
      componentKey: 0,
      selectCountryDialog: false,
      isDashboard: true,
      waterMark: "Select a Range",
      dateRange2: null,
      dateRange: { startDate: "", endDate: "" },
      workingCountry: null,
      JobListTypes: [],
      operation: "",
      operationName: "",
      driverSearch: "",
      subJobType: "",
      cancellationType: [],
      cancelType: "",
      dateToday: moment(new Date()).format("YYYY/MM/DD HH:mm"),
      pages: 1,
      FilterDateBool: false,
      userNameList: [],
      selects: { status: "", abbr: "" },
      jobsort: [
        { status: "Sort by Job ID", abbr: "JobId" },
        { status: "Sort by Date", abbr: "Date" },
      ],
      rules: {
        // required: value => !!value || "This field is required.",
        emailRules: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "E-mail must be valid",
        countryCode: (v) =>
          /^(\+?\d{1,3}|\d{1,4})$/.test(v) ||
          "Please Enter Valid Country Code.",
        phoneNumber: (v) =>
          /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(v) ||
          "Please Enter Valid Mobile No.",
        number: (v) => /^[0-9]*$/.test(v) || "Please Enter Valid Price",
      },
      // ----- NOTIFICATION ---
      newUnassigned: 0,
      newInprogress: 0,
      newCompleted: 0,

      title: null,
      message: null,
      dialog: false,
      dialog3: false,
      selectedUserId: "",

      cancelTitle: null,
      cancelMessage: null,
      cancelTitle1: null,
      cancelMessage1: null,
      dialog2: false,
      cancelComments: "",
      showAdvanceWarning: false,
      advancePaidAmount: 0,
      advanceCurrency: "",

      options: {
        color: "#ffc04c",
        width: 500,
        zIndex: 200,
      },
      x: {
        error: null,
      },
      currentEnquiry: null,
      currentIndex: null,
      paginationURL: ``,
      startDate: "",
      select: { status: "", abbr: "" },

      status: "",
      tabStatus: "Unassigned",
      tabStatusMain: "Jobs",
      executive: "",

      searchItems: [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        // { status: "Driver ID", abbr: "id" },
        // {
        //   status: "Driver Name",
        //   abbr: "name",
        // },
        // { status: "Truck Number", abbr: "truckNumber" },
      ],
      driverSearchItems: [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        // { status: "Driver ID", abbr: "id" },
        // {
        //   status: "Driver Name",
        //   abbr: "name",
        // },
        // { status: "Truck Number", abbr: "truckNumber" },
      ],
      driverSearch: "",
      driverSearchTypes: "",
      searchTypes: "",
      search: "",
      totalInquiry: 0,
      totalDriverAssigned: 0,
      totalFindingDrivers: 0,
      inactiveJob: 0,
      completedJob: 0,
      totalJob: 0,
      totalPages: 0,
      jobStatus: "",
      pagination: {},
      isNoSearchResult: false,
      loading: false,
      paginationLoading: false,
      server: false,
      headers: procurementList,
      items: [],
    };
  },
  props: {
    updateList: Number,
  },
  watch: {
    dateRange2(val) {
      if (val) {
        if (val[0] && val[1]) {
          this.startDate = moment(val[0]).format("YYYY-MM-DD");
          this.endDate = moment(val[1]).format("YYYY-MM-DD");
        }
        this.searchData(null, val);
      } else {
        this.startDate = "";
        this.endDate = "";

        localStorage.removeItem("ProenddateFilter");
        localStorage.removeItem("ProtartdateFilter");
        this.searchData(null, val);
      }
    },
    pagination(val) {
      let temp_url = "";
      if (val["sortBy"] === "createdDate") {
        if (val["descending"] === true) {
          temp_url = "&toSort=date&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=date&sortBy=descending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (val["sortBy"] === "quote") {
        if (val["descending"] === true) {
          temp_url = "&toSort=price&sortBy=descending";
          this.updateQueryStringParameter("toSort", "price");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=price&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "price");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (!val["sortBy"]) {
        this.removeParam(["toSort", "sortBy"]);
      }
      this.updateQueryStringParameter("isSearch", "true");
      deep: true;
    },
  },
  methods: {
    redirectTo(type) {
      if (type === "Jobs") {
        this.$router.push(`/procurements`);
      } else {
        this.$router.push(`/assignments`);
      }
    },
    async check(jobId) {
      this.operationName = "view-details-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.$router.push(`/jobs/${jobId}`);
      } else {
        return;
      }
    },
    async checkAddJob() {
      this.operationName = "add-new-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);

      if (y) {
        if (localStorage.getItem("workingCountries")) {
          this.workingCountries = JSON.parse(
            localStorage.getItem("workingCountries")
          );
          let workingCountry = [];
          this.workingCountries.forEach((key, index) => {
            if (key.isSelected) {
              workingCountry.push(key.value);
            }
          });
          if (workingCountry.length === 1) {
            this.$router.push(`/procurement/new`);
          } else {
            this.selectCountryDialog = true;
          }
        }
      } else {
        return;
      }
    },

    removeParam(keys) {
      let sourceURL = localStorage.getItem("paginationUrlProcure");
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (keys.indexOf(param) >= 0) {
            params_arr.splice(i, 1);
          }
        }
        rtn = rtn + "?" + params_arr.join("&");
      }
      this.paginationURL = rtn;
    },
    updateQueryStringParameter(key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = this.paginationURL.indexOf("?") !== -1 ? "&" : "?";
      if (this.paginationURL.match(re)) {
        this.paginationURL = this.paginationURL.replace(
          re,
          "$1" + key + "=" + value + "$2"
        );
      } else {
        this.paginationURL = this.paginationURL + separator + key + "=" + value;
      }
    },

    updatePaginationUrl() {
      let tempUrl = localStorage.getItem("paginationUrlProcure");
      let x = tempUrl.split("&");
      let y = x[0].split("=");
      y[1] = this.workingCountry;
      x[0] = y.join("=");
      tempUrl = x.join("&");
      this.paginationURL = tempUrl;
      this.getJobListCount();
    },
    getJobTypeWithCount(type) {
      var stringAir = "";
      var stringSea = "";
      var stringLand = "";
      if (type) {
        var count = {};
        var string = "";
        type.forEach(function (i) {
          count[i] = (count[i] || 0) + 1;
        });
        if (count["2"] > 0) {
          stringAir = "Air-" + count["2"];
        }
        if (count["3"] > 0) {
          stringSea = "Sea-" + count["3"];
        }
        if (count["1"] > 0) {
          stringLand = "Land-" + count["1"];
        }
        if (stringAir.length > 0 || stringSea.length > 0) {
          stringLand = stringLand.length > 0 ? stringLand + ", " : stringLand;
        }
        if (stringSea.length > 0) {
          stringAir = stringAir.length > 0 ? stringAir + ", " : stringAir;
        }
        return stringLand + stringAir + stringSea;
      } else {
        return "Land-1";
      }
    },
    isOnlyLand(type) {
      if (type) {
        var count = {};
        var string = "";
        type.forEach(function (i) {
          count[i] = (count[i] || 0) + 1;
        });
        if (count["1"] > 1 || count["3"] > 0 || count["2"] > 0) {
          return false;
        } else {
          return true;
        }
      }
    },
    getJobType(type) {
      switch (type) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },
    getDates(startdate, time) {
      var test = moment.unix(startdate).format("YYYY/MM/DD") + " " + time;

      var diff = Math.abs(new Date(test) - new Date(this.dateToday)); // hours
      var minutes = Math.floor(diff / 1000 / 60);
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var difference =
        (new Date(test).getTime() - new Date(this.dateToday).getTime()) / 1000;
      difference /= 60 * 60;

      return Math.abs(Math.round(difference));
    },
    page(event) {
      this.pages = event;
    },
    getUserList(assignmentWorkingCountry) {
      const url = `${this.constants.apiUrl}/user/adminList?workingCountry=${assignmentWorkingCountry}`;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios.get(url, config).then(
        (response) => {
          console.log(response.data.data);
          this.userNameList.push(...response.data.data);
          console.log(response);
        },
        (error) => {
          // this.x.error = "Failed to Fetch User Details";
        }
      );
    },
    bidSuccess(event) {},
    searchData(jobStatusVal = null, dateRangeVal = null) {
      if (this.searchTypes.abbr) {
        if (localStorage.getItem("TabStatus") == "In-progress" || "Completed") {
          this.driverSearchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "id" },
            {
              status: "Driver Name",
              abbr: "name",
            },
            { status: "Truck Number", abbr: "truckNumber" },
          ];
        }
        if (
          localStorage.getItem("TabStatus") == "Unassigned" ||
          !localStorage.getItem("TabStatus")
        ) {
          this.driverSearchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
          ];
        }
        this.driverSearchItems.forEach((k) => {
          if (k["abbr"] == this.searchTypes.abbr) {
            let elementPos = this.driverSearchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.driverSearchItems.splice(elementPos, 1);
          }
        });
      }
      if (this.driverSearchTypes.abbr) {
        if (localStorage.getItem("TabStatus") == "In-progress" || "Completed") {
          this.searchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "id" },
            {
              status: "Driver Name",
              abbr: "name",
            },
            { status: "Truck Number", abbr: "truckNumber" },
          ];
        }
        if (
          localStorage.getItem("TabStatus") == "Unassigned" ||
          !localStorage.getItem("TabStatus")
        ) {
          this.searchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
          ];
        }
        this.searchItems.forEach((k) => {
          if (k["abbr"] == this.driverSearchTypes.abbr) {
            let elementPos = this.searchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.searchItems.splice(elementPos, 1);
          }
        });
      }
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }

      let timezone = momentTz.tz.guess(); //not used
      let url = [];
      url.push(`workingCountry=${this.workingCountry}`);

      url.push(`isSearch=true`);

      if (jobStatusVal) {
        if (jobStatusVal == "In-progress" || "Completed") {
          this.searchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "id" },
            {
              status: "Driver Name",
              abbr: "name",
            },
            { status: "Truck Number", abbr: "truckNumber" },
          ];
          this.driverSearchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "id" },
            {
              status: "Driver Name",
              abbr: "name",
            },
            { status: "Truck Number", abbr: "truckNumber" },
          ];
          this.driverSearchItems.forEach((k) => {
            if (k["abbr"] == this.searchTypes.abbr) {
              let elementPos = this.driverSearchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.driverSearchItems.splice(elementPos, 1);
            }
          });
          this.searchItems.forEach((k) => {
            if (k["abbr"] == this.driverSearchTypes.abbr) {
              let elementPos = this.searchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.searchItems.splice(elementPos, 1);
            }
          });
        }
        if (jobStatusVal == "Unassigned") {
          this.searchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
          ];
          this.driverSearchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
          ];
          this.driverSearchItems.forEach((k) => {
            if (k["abbr"] == this.searchTypes.abbr) {
              let elementPos = this.driverSearchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.driverSearchItems.splice(elementPos, 1);
            }
          });
          this.searchItems.forEach((k) => {
            if (k["abbr"] == this.driverSearchTypes.abbr) {
              let elementPos = this.searchItems
                .map(function (x) {
                  return x.abbr;
                })
                .indexOf(k["abbr"]);

              this.searchItems.splice(elementPos, 1);
            }
          });
        }
        this.paginationURL = "";
        this.newUnassigned = 0;
        this.newInprogress = 0;
        this.newCompleted = 0;
        localStorage.setItem("TabStatus", jobStatusVal);
        this.tabStatus = jobStatusVal;
        url.push(`status=${jobStatusVal}`);
      } else {
        this.jobStatus = this.tabStatus;
        url.push(`status=${this.tabStatus}`);
      }

      // if (
      //   this.search == localStorage.getItem("searchProcurement") ||
      //   this.driverSearch == localStorage.getItem("searchProcurementDriver")
      // ) {
      //   return;
      // }

      // if (this.dateRange.startDate && this.dateRange.endDate) {
      //   this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      //   this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      // }
      if (dateRangeVal) {
        localStorage.setItem("ProtartdateFilter", JSON.stringify(dateRangeVal));

        url.push(`startDate=${this.startDate}`);
        url.push(`endDate=${this.endDate}`);
      } else if (this.startDate.length > 0) {
        url.push(`startDate=${this.startDate}`);
        url.push(`endDate=${this.endDate}`);
      }

      if (this.subJobType) {
        localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
        url.push(`jobType=${this.subJobType.value}`);
      }

      if (this.search.trim().length > 0 && this.searchTypes) {
        localStorage.setItem("searchProcurement", this.search);
        localStorage.setItem(
          "searchProcurementType",
          JSON.stringify(this.searchTypes)
        );

        url.push(`searchType=${this.searchTypes.abbr}`);
        url.push(`searchText=${this.search}`);
      } else if (this.searchTypes) {
        // localStorage.removeItem("searchProcurement");
        // localStorage.removeItem("searchProcurementType");
        // url.push(`searchType=${this.searchTypes.abbr}`);
        // this.search = "";
      }

      if (this.driverSearch.trim().length > 0 && this.driverSearchTypes) {
        this.isDashboard = false;
        localStorage.setItem("searchProcurementDriver", this.driverSearch);
        localStorage.setItem(
          "searchProcurementDriverType",
          JSON.stringify(this.driverSearchTypes)
        );

        url.push(`searchTextTwo=${this.driverSearch}`);
        url.push(`searchTypeTwo=${this.driverSearchTypes.abbr}`);
      } else if (this.driverSearchTypes) {
        // this.isDashboard = true;
        // localStorage.removeItem("searchProcurementDriver");
        // localStorage.removeItem("searchProcurementDriverType");
        // url.push(`searchTypeTwo=${this.driverSearchTypes.abbr}`);
        // this.driverSearch = "";
      }

      let finalUrl = "/dmsAdmin/newjobList?";
      if (url.length > 0) {
        let params = url.join("&");
        finalUrl = finalUrl + params;
      } else return "";

      this.loading = true;
      this.paginationURL = finalUrl;
      this.getJobListCount();
    },
    // searchByType() {
    //   if (
    //     (this.searchTypes && this.search.trim().length > 0) ||
    //     this.select.abbr ||
    //     this.startDate ||
    //     this.search ||
    //     this.subJobType ||
    //     this.driverSearch
    //   ) {
    //     this.search = "";
    //     this.searchAnything();
    //   }
    // },
    // searchByDriverType() {
    //   if (
    //     (this.driverSearchTypes && this.driverSearch.trim().length > 0) ||
    //     this.select.abbr ||
    //     this.startDate ||
    //     this.subJobType ||
    //     this.search
    //   ) {
    //     this.driverSearch = "";
    //     this.driverSearchAnything();
    //   }
    // },

    refreshOnComment() {
      this.componentKey++;
    },
    refreshBid(event) {
      this.componentKey++;

      // for (var i = 0; i < this.items.length; i++) {
      //   if (event.jobId === this.items[i].jobId) {
      //     if (event.jobModel) {
      //       this.items[i].isAcknowedged = true;
      //       this.items[i].isTransporterJob = true;
      //       this.items[i].jobModel = event.jobModel;
      //     } else {
      //       this.items[i].isAcknowedged = true;
      //       this.items[i].isDriverJob = true;
      //     }
      //   }
      // }
    },
    startSocket: function () {
      var socket = io(this.constants.apiUrl, {
        query: "adminToken=" + localStorage.getItem(StorageKeys.SessionKey),
        forceNew: true,
      });
      socket.on("connect", () => {});
      socket.on("unassignedJob", (data) => {
        this.newUnassigned = this.newUnassigned + 1;
        new Audio(
          require("../../assets/elevator-ding.mp3")
        ).play();
      });
      socket.on("assignedDriver", (data) => {
        this.newInprogress = this.newInprogress + 1;
        new Audio(
          require("../../assets/elevator-ding.mp3")
        ).play();
      });
      socket.on("completeAssignment", (data) => {
        this.newCompleted = this.newCompleted + 1;
        new Audio(
          require("../../assets/elevator-ding.mp3")
        ).play();
      });
    },
    open3(val, index) {
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }
      if (!this.cancelType) {
        this.x.error = "Please select cancellation reason before moving ahead";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return false;
      }
      if (this.cancelType.value == "Other’s") {
        if (!this.cancelComments.trim()) {
          this.x.error = "Please enter cancellation reason before moving ahead";
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
          return false;
        }
      }
      this.dialog3 = true;
      this.dialog2 = false;
      this.cancelTitle1 = "Cancellation Message";
      this.cancelMessage1 = "Your job has been cancelled!";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel3() {
      this.resolve(false);
      this.dialog3 = false;
    },
    open2(val, index) {
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }
      console.log(val.totalAdvancePaidAmount, "---val");

      this.currentEnquiry = val;
      this.currentIndex = index;

      this.cancelComments = "";
      this.cancelType = "";

      // Check if advance amount is paid
      if (
        val.totalAdvancePaidAmount !== null &&
        val.totalAdvancePaidAmount > 0
      ) {
        this.showAdvanceWarning = true;
        this.advancePaidAmount = val.totalAdvancePaidAmount;
        this.advanceCurrency = val.customerCurrency || "";
      } else {
        this.showAdvanceWarning = false;
        this.advancePaidAmount = 0;
        this.advanceCurrency = "";
      }

      this.dialog2 = true;
      this.cancelTitle = "Cancel Job";
      this.cancelMessage = "On clicking YES this job will be cancelled";

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree2() {
      this.resolve(true);

      this.cancelJob(this.currentEnquiry, this.currentStatus);
      this.dialog2 = false;
    },
    cancel2() {
      this.resolve(false);
      this.dialog2 = false;
      this.showAdvanceWarning = false;
      this.advancePaidAmount = 0;
      this.advanceCurrency = "";
    },
    async cancelJob(value, status) {
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }

      this.loading = true;
      let url = "/dmsAdmin/cancelJob";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        jobId: this.items[this.currentIndex].jobId.toString(),
        type: 1,
      };
      this.operationName = "cancel-assignment-job-master";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        body["admin_type"] = "MasterADMIN";
      } else {
        body["admin_type"] = "ADMIN";
      }
      if (this.cancelType.value) {
        if (this.cancelType.value == "Other’s") {
          body.cancellationReason =
            this.cancelType.value + " - " + this.cancelComments.trim();
        } else {
          body.cancellationReason = this.cancelType.value;
        }
      }

      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.items[this.currentIndex].jobStatus = -1;
          this.dialog3 = false;

          this.loading = false;
        },
        (error) => {
          this.loading = false;

          this.x.error = error.response.data.message;
          setTimeout(function () {
            this.x.error = "";
          }, 3000);
        }
      );
    },

    open(val, index, workingCountry) {
      console.log(workingCountry);
      this.getUserList(workingCountry);
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }
      this.currentEnquiry = val;
      this.currentIndex = index;
      this.selectedUserId = "";

      this.dialog = true;
      this.title = "Acknowledge Job";
      this.message = "Click Yes to acknowledge this job";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      if (this.selectedUserId.trim()) {
        this.updateStatus(this.currentEnquiry, this.currentStatus);
        this.dialog = false;
      } else {
        this.x.error = "Please provide User Name for Procured";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return false;
      }
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
    updateStatus(value, status) {
      this.loading = true;
      let url = "/dmsAdmin/acknowledgeProcurement";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      let body = {
        jobId: this.items[this.currentIndex].jobId.toString(),
      };
      if (this.selectedUserId) {
        body.procurementExec = this.selectedUserId.trim();
      }
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.identify(localStorage.getItem("email"));
          this.track("Job Acknowledge", {
            "Job Id": value.jobId.toString(),
            "Company Name/Customer Name":
              value.companyName || value.customer || value.customerEmail,
            "No. of assignmnets": value.numberOfAssignmentsRequired,
            "Job Start Date": moment.unix(value.startDate).format(),
            "Working Country": value.workingCountry,
            "Selling Price": value.jobPrice,
          });
          this.items[this.currentIndex].isAcknowedged = true;
          this.items[this.currentIndex].jobStatus = 4;
          this.loading = false;
        },
        (error) => {
          this.loading = false;

          this.x.error = error.response.data.message;
        }
      );
    },
    goToProfile(jobId) {
      this.$router.push(`/jobs/${jobId}`);
    },
    getTime(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    getTime3(date) {
      return moment.utc(date).format("ll");
    },
    getTime4(date) {
      return moment(date).format("ll LT");
    },
    getLatestCommentTime(lastComment) {
      if (
        !lastComment ||
        typeof lastComment !== "object" ||
        !lastComment.comment ||
        !String(lastComment.comment).trim()
      ) {
        return "";
      }

      const commentDate =
        lastComment.createdAt ||
        lastComment.updatedAt ||
        lastComment.created_at ||
        lastComment.updated_at ||
        lastComment.commentDate ||
        lastComment.commentTime ||
        lastComment.date ||
        lastComment.created ||
        lastComment.updated ||
        lastComment.timestamp ||
        lastComment.time;

      return commentDate ? this.getTime4(commentDate) : "";
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Active";
        case 2:
          return "Completed";
        case 3:
          return "Customer Rate Accepted";
        case 4:
          return "Finding Drivers";
        case 5:
          return "Driver Assigned";
        case 6:
          return "In-Transit";
        case 7:
          return "Shipment Offloaded & POD Awaited";
        case 8:
          return "Payment Pending";
        case 9:
          return "Payment Done";
        case 10:
          return "Low Credit Limit";

        case -1:
          return "Cancelled";
        default:
          return "Unknown";
      }
    },
    checkLoading(event) {
      if (event) {
        this.$emit("job-load", true);
      } else {
        this.$emit("job-load", false);
      }
    },

    // searchAnything() {
    //   if (!navigator.onLine) {
    //     this.loading = false;
    //     this.x.error = "Please check your internet connection";
    //     setTimeout(() => {
    //       this.x.error = "";
    //     }, 3000);
    //     return;
    //   }
    //   if (this.search == localStorage.getItem("searchProcurement")) {
    //     return;
    //   }
    //   if (this.dateRange.startDate && this.dateRange.endDate) {
    //     this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
    //     this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
    //   }
    //   let timezone = momentTz.tz.guess();
    //   if (this.search.trim().length > 0) {
    //     localStorage.setItem("searchProcurement", this.search);
    //     localStorage.setItem(
    //       "searchProcurementType",
    //       JSON.stringify(this.searchTypes)
    //     );
    //     this.jobStatus = this.tabStatus;
    //     let url = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&status=${this.tabStatus}&isSearch=true&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
    //     if (this.startDate) {
    //       url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
    //     }
    //     if (this.subJobType) {
    //       url = url + `&jobType=${this.subJobType.value}`;
    //     }
    //     if (this.driverSearch) {
    //       url =
    //         url +
    //         `&driverSearchText=${this.driverSearch}&driverSearchType=${this.driverSearchTypes.abbr}`;
    //     }
    //     this.loading = true;
    //     this.paginationURL = url;
    //   } else {
    //     localStorage.removeItem("searchProcurement");
    //     localStorage.removeItem("searchProcurementType");
    //     this.jobStatus = this.tabStatus;
    //     let url = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&status=${this.tabStatus}&isSearch=true&searchType=${this.searchTypes.abbr}`;
    //     if (this.startDate) {
    //       url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
    //     }
    //     if (this.subJobType) {
    //       url = url + `&jobType=${this.subJobType.value}`;
    //     }
    //     if (this.driverSearch) {
    //       url =
    //         url +
    //         `&driverSearchText=${this.driverSearch}&driverSearchType=${this.driverSearchTypes.abbr}`;
    //     }
    //     this.loading = true;
    //     this.paginationURL = url;
    //   }
    // },
    // driverSearchAnything() {
    //   if (!navigator.onLine) {
    //     this.loading = false;
    //     this.x.error = "Please check your internet connection";
    //     setTimeout(() => {
    //       this.x.error = "";
    //     }, 3000);
    //     return;
    //   }
    //   if (
    //     this.driverSearch == localStorage.getItem("searchProcurementDriver")
    //   ) {
    //     return;
    //   }
    //   if (this.dateRange.startDate && this.dateRange.endDate) {
    //     this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
    //     this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
    //   }
    //   let timezone = momentTz.tz.guess();
    //   if (this.driverSearch.trim().length > 0) {
    //     this.isDashboard = false;
    //     localStorage.setItem("searchProcurementDriver", this.driverSearch);
    //     localStorage.setItem(
    //       "searchProcurementDriverType",
    //       JSON.stringify(this.driverSearchTypes)
    //     );
    //     this.jobStatus = this.tabStatus;
    //     let url = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&status=${this.tabStatus}&isSearch=true&driverSearchText=${this.driverSearch}&driverSearchType=${this.driverSearchTypes.abbr}`;
    //     if (this.startDate) {
    //       url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
    //     }
    //     if (this.subJobType) {
    //       url = url + `&jobType=${this.subJobType.value}`;
    //     }
    //     if (this.search) {
    //       url =
    //         url +
    //         `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
    //     }
    //     this.loading = true;
    //     this.paginationURL = url;
    //   } else {
    //     this.isDashboard = true;
    //     localStorage.removeItem("searchProcurementDriver");
    //     localStorage.removeItem("searchProcurementDriverType");
    //     this.jobStatus = this.tabStatus;
    //     let url = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&status=${this.tabStatus}&isSearch=true&driverSearchType=${this.driverSearchTypes.abbr}`;
    //     if (this.startDate) {
    //       url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
    //     }
    //     if (this.subJobType) {
    //       url = url + `&jobType=${this.subJobType.value}`;
    //     }
    //     if (this.select.length) {
    //       url = url + `&status=${JSON.stringify(this.select)}`;
    //     }
    //     if (this.search) {
    //       url =
    //         url +
    //         `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
    //     }

    //     this.loading = true;
    //     this.paginationURL = url;
    //   }
    // },

    // async filterByJobStatus(val) {
    //   if (!navigator.onLine) {
    //     this.loading = false;
    //     this.x.error = "Please check your internet connection";
    //     setTimeout(() => {
    //       this.x.error = "";
    //     }, 3000);
    //     return;
    //   }
    //   if (this.dateRange.startDate && this.dateRange.endDate) {
    //     this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
    //     this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
    //   }
    //   this.newUnassigned = 0;
    //   this.newInprogress = 0;
    //   this.newCompleted = 0;
    //   let timezone = momentTz.tz.guess();
    //   localStorage.setItem("TabStatus", val);
    //   this.tabStatus = val;
    //   this.paginationURL = "";
    //   let url = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&isSearch=true&status=${val}`;
    //   if (this.startDate) {
    //     url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
    //   }
    //   if (this.search) {
    //     url =
    //       url +
    //       `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
    //   }
    //   if (this.subJobType) {
    //     url = url + `&jobType=${this.subJobType.value}`;
    //   }
    //   if (this.driverSearch) {
    //     url =
    //       url +
    //       `&driverSearchText=${this.driverSearch}&driverSearchType=${this.driverSearchTypes.abbr}`;
    //   }
    //   this.paginationURL = url;
    // },
    // async jobTypeFilter() {
    //   if (!navigator.onLine) {
    //     this.loading = false;
    //     this.x.error = "Please check your internet connection";
    //     setTimeout(() => {
    //       this.x.error = "";
    //     }, 3000);
    //     return;
    //   }
    //   let timezone = momentTz.tz.guess();
    //   localStorage.setItem("subJobTypePro", JSON.stringify(this.subJobType));
    //   this.jobStatus = this.tabStatus;
    //   let url = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&status=${this.tabStatus}&isSearch=true&jobType=${this.subJobType.value}`;
    //   if (this.startDate) {
    //     url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
    //   }
    //   if (this.search) {
    //     url =
    //       url +
    //       `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
    //   }
    //   if (this.driverSearch) {
    //     url =
    //       url +
    //       `&driverSearchText=${this.driverSearch}&driverSearchType=${this.driverSearchTypes.abbr}`;
    //   }
    //   this.loading = true;
    //   this.paginationURL = url;
    // },
    reset() {
      if (localStorage.getItem("TabStatus") == "In-progress" || "Completed") {
        this.driverSearchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];

        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];
      }
      if (
        localStorage.getItem("TabStatus") == "Unassigned" ||
        !localStorage.getItem("TabStatus")
      ) {
        this.driverSearchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
        ];
        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
        ];
      }
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.xerror = "";
        }, 3000);
        return;
      }
      localStorage.removeItem("subJobTypePro");
      localStorage.removeItem("ProtartdateFilter");
      localStorage.removeItem("ProenddateFilter");
      localStorage.removeItem("searchProcurement");
      localStorage.removeItem("searchProcurementType");
      localStorage.removeItem("searchProcurementDriver");
      localStorage.removeItem("searchProcurementDriverType");
      localStorage.removeItem("paginationUrlProcure");
      this.jobStatus = this.tabStatus;
      this.startDate = "";
      this.select = { status: "", abbr: "" };
      this.selects = { status: "", abbr: "" };
      this.status = "";
      this.dateRange2 = null;
      this.subJobType = "";
      this.executive = "";
      this.search = "";
      this.driverSearchTypes = "";
      this.isDashboard = true;
      this.driverSearch = "";
      this.searchTypes = "";
      this.paginationURL = `/dmsAdmin/newjobList?workingCountry=${this.workingCountry}&isSearch=true&status=${this.jobStatus}`;
      this.getJobListCount();
      return;
    },
    getJobListCount() {
      let v = {};
      this.paginationLoading = true;
      let Url = "/dmsAdmin/newjobListCount";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      this.axios.defaults.headers.common["authorization"] = `bearer ${token}`;

      let temp_url = this.paginationURL;
      Url = "/dmsAdmin/newjobListCount?" + temp_url.split("?")[1];
      let body = {};

      v = this.axios.get(this.constants.apiUrl + Url, body).then(
        (response) => {
          this.paginationLoading = false;
          this.jobCount = response.data.data;
          let countData = this.jobCount;
          this.totalFindingDrivers = countData.totalFindingDrivers;
          this.totalDriverAssigned = countData.totalDriverAssigned;
          this.totalJob = countData.totalData;
          this.totalPages = Math.ceil(this.totalJob / 15);
        },
        (error) => {
          this.paginationLoading = false;
        }
      );

      return v;
    },

    getLocation(...val) {
      return val ? val.reduce((val, curr) => val + ", " + curr) : "";
    },
    async callback({
      jobInfo,
      totalInquiry,
      totalData,
      totalDriverAssigned,
      totalFindingDrivers,
    }) {
      // this.getJobListCount();

      this.items = jobInfo;
      this.totalInquiry = totalInquiry;
      this.pagination.rowsPerPage = 15;
      this.$emit("job-load", false);
      window.scrollTo(0, 0);
      this.loading = false;
    },
    submit() {
      this.loading = true;
      let url = "/dmsAdmin/sendJobToTransport";
      // delete this.axios.defaults.headers.common["token"];
      // let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          // authorization: `bearer ${token}`,
        },
      };
      let body = {};

      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.items = response.data.data;

          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.x.error = "Failed to update status";
        }
      );
    },
  },
};
</script>

<style lang="scss">
.procurement-revamp {
  /* Two text sizes for the whole list: row content, and the smaller size shared
     by column headers, FROM/TO labels, status pills and row buttons. */
  --proc-cell-text: 0.75rem;
  --proc-cell-label: 0.6875rem;
  --proc-bg: #f6f5f2;
  --proc-panel: #ffffff;
  --proc-ink: #3a382f;
  --proc-navy: #1a1916;
  --proc-muted: #74716a;
  --proc-soft: #fbfaf7;
  --proc-primary: #2456b8;
  --proc-primary-dark: #17428f;
  --proc-primary-soft: #eaf1fd;
  --proc-border: #ebe9e2;
  --proc-action: #ea7a1c;
  --proc-action-dark: #d96a10;
  --proc-action-soft: #fdf0e4;
  --proc-row: #ffffff;
  --proc-shadow: 0 1px 2px rgba(26, 25, 22, 0.04);
  background: var(--proc-bg);
  color: var(--proc-ink);
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  min-height: calc(100vh - 54px);
  padding: 4px;
}

.procurement-panel {
  background: var(--proc-panel) !important;
  border: 1px solid var(--proc-border) !important;
  border-radius: 16px !important;
  box-shadow: var(--proc-shadow) !important;
  overflow: visible;
}

.procurement-board-head {
  align-items: flex-start;
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(251, 250, 247, 0.98) 62%,
      rgba(253, 240, 228, 0.98) 100%
    ),
    #ffffff;
  border-bottom: 1px solid #f0eee8;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: space-between;
  padding: 18px 30px;
}

.procurement-title-area span {
  color: var(--proc-primary-dark);
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.procurement-title-area h1 {
  color: var(--proc-navy);
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 4px 0 0;
}

.procurement-head-controls {
  align-items: stretch;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(128px, auto) minmax(640px, 1fr);
  max-width: 860px;
  min-width: 0;
  width: 100%;
}

.procurement-tab-stack {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.procurement-nav-grid {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #f0eee8;
  display: grid;
  gap: 12px;
  grid-template-columns: var(
    --oms-list-nav-columns,
    minmax(260px, 0.5fr) minmax(360px, 1fr) auto
  );
  padding: var(--oms-list-section-y, 12px) var(--oms-list-section-x, 30px);
}

.procurement-nav-grid .procurement-status-tabs {
  justify-self: end;
}

.procurement-nav-grid .procurement-primary-tabs,
.procurement-nav-grid .procurement-status-tabs {
  max-width: 100%;
  width: fit-content;
}

.procurement-status-tabs ::v-deep .segmented-control__item--active {
  background: var(--proc-primary-soft);
  color: var(--proc-primary-dark);
}

.procurement-revamp .procurement-primary-tabs,
.procurement-revamp .procurement-status-tabs {
  border-radius: 8px;
  overflow-x: auto !important;
  overflow-y: hidden !important;
}

.procurement-revamp .procurement-primary-tabs .v-tabs__bar,
.procurement-revamp .procurement-status-tabs .v-tabs__bar {
  background: #f4f3ee !important;
  border: 1px solid var(--proc-border);
  border-radius: 8px;
  box-shadow: none !important;
  min-height: 42px;
  overflow-x: auto;
  padding: 5px;
}

.procurement-revamp .procurement-primary-tabs .v-tabs__container,
.procurement-revamp .procurement-status-tabs .v-tabs__container {
  min-height: 32px;
  min-width: max-content;
}

.procurement-revamp .procurement-primary-tabs .v-tabs__item,
.procurement-revamp .procurement-status-tabs .v-tabs__item {
  border-radius: 7px;
  color: var(--proc-muted) !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  min-height: 32px;
  padding: 7px 12px;
  text-transform: none;
}

.procurement-revamp .procurement-primary-tabs .v-tabs__item--active,
.procurement-revamp .procurement-status-tabs .v-tabs__item--active {
  background: #ffffff;
  box-shadow: 0 5px 16px rgba(26, 25, 22, 0.08);
  color: var(--proc-primary-dark) !important;
}

.procurement-revamp .v-tabs__slider {
  display: none;
}

.procurement-revamp .tab-span {
  align-items: center;
  background: var(--proc-primary-soft);
  border-radius: 999px;
  color: var(--proc-primary-dark);
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  justify-content: center;
  line-height: 1;
  margin-left: 6px;
  min-width: 20px;
  padding: 5px 7px;
}

.procurement-add-job-btn {
  align-self: start;
  background: var(--proc-primary) !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 18px rgba(234, 122, 28, 0.22) !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  height: 42px !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  min-width: 154px;
  overflow: visible !important;
  padding: 0 14px !important;
  text-transform: none !important;
  white-space: nowrap;
}

.procurement-add-job-btn .v-btn__content,
.procurement-add-job-btn .v-icon {
  color: #ffffff !important;
  font-size: 18px;
  opacity: 1 !important;
}

.procurement-add-job-btn .v-btn__content {
  align-items: center;
  display: inline-flex;
  font-size: 12px;
  gap: 4px;
  justify-content: center;
}

.procurement-stats-grid {
  background: #ffffff;
  display: grid;
  gap: 10px;
  grid-template-columns: var(
    --oms-list-stat-columns,
    repeat(4, minmax(13rem, 1fr)) minmax(11.5rem, 13rem)
  );
  padding: var(--oms-list-section-y, 14px) var(--oms-list-section-x, 30px);
}

.procurement-stat-card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.94), #ffffff),
    var(--proc-row);
  border: 1px solid var(--proc-border);
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(26, 25, 22, 0.04);
  min-height: 78px;
  padding: 13px 14px 12px 56px;
  position: relative;
}

.procurement-stat-card::before {
  background: var(--proc-primary);
  border-radius: 8px 0 0 8px;
  content: "";
  inset: 0 auto 0 0;
  position: absolute;
  width: 4px;
}

.procurement-stat-icon {
  align-items: center;
  background: var(--proc-primary-soft);
  border-radius: 8px;
  display: flex;
  height: 32px;
  justify-content: center;
  left: 14px;
  position: absolute;
  top: 14px;
  width: 32px;
}

.procurement-stat-icon .v-icon {
  color: var(--proc-primary-dark);
  font-size: 18px;
}

.procurement-stat-card span {
  color: var(--proc-muted);
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.procurement-stat-card strong {
  color: var(--proc-ink);
  display: block;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  margin-top: 5px;
}

.procurement-stat-card small {
  color: #9e9a91;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}

.procurement-stat-card--assigned::before,
.procurement-stat-card--assigned .procurement-stat-icon {
  background: #12764c;
}

.procurement-stat-card--assigned .procurement-stat-icon .v-icon,
.procurement-stat-card--finding .procurement-stat-icon .v-icon,
.procurement-stat-card--total .procurement-stat-icon .v-icon {
  color: #ffffff;
}

.procurement-stat-card--total::before,
.procurement-stat-card--total .procurement-stat-icon {
  background: #2456b8;
}

.procurement-stat-card--inquiry::before,
.procurement-stat-card--inquiry .procurement-stat-icon {
  background: #b5820f;
}

.procurement-stat-card--inquiry .procurement-stat-icon .v-icon {
  color: #ffffff;
}

.procurement-stat-card--finding::before,
.procurement-stat-card--finding .procurement-stat-icon {
  background: #be3b32;
}

/* The four cards above are hand-built articles; Add Job is the shared StatCard
   component, which came with its own frame, an inline icon and no accent line.
   Give it the same shell, accent line, icon tile and type as its neighbours,
   in the action colour. */
#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.94), #ffffff),
    var(--proc-row);
  border: 1px solid var(--proc-border);
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(26, 25, 22, 0.04);
  display: block;
  justify-self: stretch;
  max-width: none;
  min-height: 78px;
  padding: 13px 14px 12px 56px;
  position: relative;
  text-align: left;
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card::before {
  background: var(--proc-action);
  border-radius: 8px 0 0 8px;
  content: "";
  /* StatCard's own styles hide this pseudo-element. */
  display: block;
  inset: 0 auto 0 0;
  position: absolute;
  width: 4px;
}

#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card:hover {
  box-shadow: 0 10px 22px rgba(26, 25, 22, 0.1);
  transform: translateY(-1px);
}

#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card .oms-stat-card__icon {
  background: var(--proc-action);
  border-radius: 8px;
  height: 32px;
  left: 14px;
  position: absolute;
  top: 14px;
  width: 32px;
}

#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card .oms-stat-card__icon .v-icon {
  color: #ffffff;
  font-size: 18px;
}

#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card .oms-stat-card__label {
  color: var(--proc-muted);
  font-size: 11px;
  font-weight: 800;
  padding-left: 0;
}

#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card .oms-stat-card__value {
  color: var(--proc-ink);
  font-family: inherit;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  margin-top: 5px;
  padding-left: 0;
}

#nav .procurement-revamp--modern .procurement-add-job-card.oms-stat-card .oms-stat-card__caption {
  color: #9e9a91;
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
  /* This caption is longer than its neighbours', and the card sits in a
     narrower grid column: wrap rather than run past the card edge. */
  white-space: normal;
}

.procurement-filter-panel {
  background: linear-gradient(180deg, #ffffff 0%, #fbfaf7 100%);
  border: 1px solid var(--proc-border);
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
  margin: 0 var(--oms-list-section-x, 30px);
  max-width: none;
  padding: 12px 14px !important;
}

.procurement-section-title {
  margin-bottom: 12px;
}

.procurement-section-title span {
  color: var(--proc-primary-dark);
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.procurement-section-title h2 {
  color: var(--proc-navy);
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 4px 0 0;
  text-transform: capitalize;
}

.procurement-filter-grid {
  align-items: stretch;
  display: grid !important;
  gap: 10px;
  grid-template-columns:
    minmax(150px, 0.9fr)
    minmax(210px, 1.2fr)
    minmax(150px, 0.9fr)
    minmax(210px, 1.2fr)
    minmax(150px, 0.9fr)
    minmax(210px, 1fr)
    minmax(96px, auto);
  margin: 0 !important;
  padding: 0 !important;
}

.procurement-filter-grid > .flex {
  align-items: stretch;
  display: flex !important;
  flex-basis: auto !important;
  max-width: none !important;
  min-height: 42px;
  min-width: 0;
  padding: 0 !important;
  width: 100%;
}

.procurement-filter-actions .v-card__actions {
  align-items: stretch;
  padding: 0;
  width: 100%;
}

.procurement-revamp .procurement-filter-panel .v-input,
.procurement-revamp .procurement-filter-panel .wrapper,
.procurement-revamp .procurement-filter-panel #jobDate {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
}

.procurement-revamp .procurement-filter-panel .gap {
  margin: 0 !important;
}

.procurement-revamp .procurement-filter-panel .v-input__control,
.procurement-revamp .procurement-filter-panel .v-input__slot,
.procurement-revamp .procurement-filter-panel .v-select__slot,
.procurement-revamp .procurement-filter-panel .v-text-field__slot {
  min-height: 42px !important;
  width: 100%;
}

.procurement-revamp .procurement-filter-panel .v-input__slot,
.procurement-revamp .procurement-filter-panel .e-input-group {
  align-items: center !important;
  background: #fbfcfe !important;
  border: 1px solid #dfe4ec !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  box-sizing: border-box;
  height: 42px !important;
  margin: 0 !important;
  padding: 0 12px !important;
}

.procurement-revamp
  .procurement-filter-panel
  .v-text-field--outline
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #dfe4ec !important;
}

.procurement-revamp .procurement-filter-panel .e-input-group {
  padding: 6px 10px !important;
}

.procurement-revamp .procurement-filter-panel .v-text-field__details {
  display: none;
}

.procurement-revamp .procurement-filter-panel .v-label,
.procurement-revamp .procurement-filter-panel .v-select__selection,
.procurement-revamp .procurement-filter-panel input {
  color: #5f6878 !important;
  font-size: 13px;
  font-weight: 700;
}

.procurement-revamp .procurement-filter-panel .v-icon {
  color: #64748b;
  font-size: 18px;
}

.procurement-reset-link {
  background: #ffffff !important;
  border: 1px solid #dfe4ec !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  color: var(--proc-primary-dark) !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  height: 42px !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  min-width: 92px !important;
  padding: 0 12px !important;
  text-transform: none !important;
  width: 100%;
}

.procurement-reset-link .v-icon {
  color: var(--proc-primary-dark) !important;
  font-size: 16px !important;
  margin-left: 5px;
}

.procurement-table-card {
  background: #ffffff;
  overflow: visible;
  padding: 0 var(--oms-list-section-x, 30px) 28px !important;
}

.procurement-table-scroll {
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.procurement-revamp #jobsTable {
  background: transparent;
}

.procurement-revamp #jobsTable .v-table__overflow {
  background: #ffffff;
  border: 1px solid var(--proc-border);
  border-radius: 0 0 8px 8px;
  overflow-x: auto;
  width: 100%;
}

.procurement-revamp #jobsTable table.v-table {
  border-collapse: separate;
  border-spacing: 0 0.375rem;
  min-width: var(--oms-list-table-min-width, 116rem);
  table-layout: fixed;
}

.procurement-revamp #jobsTable table.v-table thead tr {
  background: transparent;
}

.procurement-revamp #jobsTable table.v-table thead th:first-child {
  border-radius: 8px 0 0 8px;
}

.procurement-revamp #jobsTable table.v-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}

.procurement-revamp #jobsTable table.v-table tbody tr {
  background: var(--proc-row);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.045);
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

.procurement-revamp #jobsTable table.v-table tbody tr:hover {
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  transform: translateY(-1px);
}

.procurement-revamp #jobsTable table.v-table tbody tr:hover td {
  background: #fbfaf7;
}

/* Jobs whose pickup is near are tinted: amber within 12 hours, red within 6.
   The tint plus the row card's own left accent carries that; the accent bar
   used to be an inset shadow on every cell, which drew an orange line down
   each column and broke the row card apart. */
.procurement-revamp #jobsTable table.v-table tbody tr.colorchange td {
  background: #fef2f2 !important;
}

.procurement-revamp #jobsTable table.v-table tbody tr.colorchange td:first-child {
  border-left-color: #be3b32 !important;
}

.procurement-revamp #jobsTable table.v-table tbody tr.colorchangeyellow td {
  background: #fdf6ea !important;
}

.procurement-revamp #jobsTable table.v-table tbody tr.colorchangeyellow td:first-child {
  border-left-color: #d98218 !important;
}

.procurement-revamp #jobsTable table.v-table tbody td {
  background: var(--proc-row);
  border-bottom: 1px solid #f3f1eb !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0 !important;
  color: #2e3748;
  font-size: 0.8125rem !important;
  height: auto;
  line-height: 1.35;
  overflow-wrap: break-word;
  padding: 0.75rem !important;
  text-align: left !important;
  vertical-align: middle;
}

.procurement-revamp #jobsTable table.v-table tbody td:first-child {
  border-left: 0 !important;
  border-radius: 8px 0 0 8px;
  color: var(--proc-action-dark);
  font-weight: 700;
  padding-left: 0.625rem !important;
}

.procurement-revamp #jobsTable table.v-table tbody td:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid #eef1f5 !important;
}

.procurement-revamp #jobsTable table.v-table tbody tr:hover td:first-child {
  border-left-color: transparent !important;
}

.procurement-job-id-row,
.procurement-country-stack,
.procurement-assignment-cell,
.procurement-status-cell,
.procurement-action-cell,
.procurement-vendor-cell,
.procurement-comment-cell {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.procurement-job-id-row {
  align-items: center;
  flex-direction: row;
}

.procurement-job-id {
  color: #0f172a;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0;
}

.procurement-country-stack {
  align-items: center;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
  gap: 4px;
  text-transform: uppercase;
}

.procurement-country-stack img {
  border-radius: 999px;
  box-shadow: 0 0 0 1px #e2e8f0;
  object-fit: cover;
  width: 28px;
}

.procurement-company-cell {
  color: #1f2937 !important;
  font-weight: 800;
  min-width: 170px;
}

.procurement-date-cell {
  color: #475569 !important;
  font-size: 12px !important;
  font-weight: 800;
  white-space: nowrap;
}

.procurement-route-cell {
  color: #334155 !important;
  font-size: 12px !important;
  font-weight: 700;
  min-width: 145px;
  padding-left: 12px !important;
  position: relative;
}

.procurement-route-cell::before {
  display: none;
}

.procurement-route-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 18px;
  position: relative;
}

.procurement-route-stack::before {
  background: var(--proc-primary);
  border-radius: 999px;
  content: "";
  height: 7px;
  left: 0;
  position: absolute;
  top: 5px;
  width: 7px;
}

.procurement-route-cell--to .procurement-route-stack::before {
  background: #2563eb;
}

.procurement-route-stack span {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  text-transform: uppercase;
}

.procurement-route-stack strong {
  color: #334155;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.25;
  overflow-wrap: break-word;
}

.procurement-route-cell--combined {
  min-width: 12.5rem;
  padding-left: 0.75rem !important;
}

.procurement-route-pair {
  display: flex;
  flex-direction: column;
  gap: 0.4375rem;
  max-width: 100%;
  min-width: 0;
  position: relative;
}

.procurement-route-pair::before {
  border-left: 1px dashed #cbd5e1;
  bottom: 1.125rem;
  content: "";
  left: 0.25rem;
  position: absolute;
  top: 1.125rem;
}

.procurement-route-point {
  display: flex;
  flex-direction: column;
  gap: 0.1875rem;
  min-width: 0;
  padding-left: 1.125rem;
  position: relative;
}

.procurement-route-point::before {
  background: var(--proc-primary);
  border: 2px solid #fff7ed;
  border-radius: 999px;
  box-shadow: 0 0 0 1px rgba(245, 130, 32, 0.24);
  content: "";
  height: 0.5625rem;
  left: 0;
  position: absolute;
  top: 0.25rem;
  width: 0.5625rem;
  z-index: 1;
}

.procurement-route-point--to::before {
  background: #2563eb;
  border-color: #eff6ff;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.22);
}

.procurement-route-point span {
  color: #64748b;
  font-size: var(--proc-cell-label);
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.procurement-route-point strong {
  color: #334155;
  display: block;
  font-size: 0.78125rem;
  font-weight: 800;
  line-height: 1.28;
  max-width: 100%;
  overflow-wrap: anywhere;
}

.procurement-price-cell {
  color: #0f172a !important;
  font-size: 14px !important;
  font-weight: 900;
  white-space: nowrap;
}

.procurement-price-cell--empty {
  color: #94a3b8 !important;
  font-weight: 800;
}

.procurement-assignment-count {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  color: #0f172a;
  display: inline-flex;
  font-size: 12px;
  font-weight: 900;
  justify-content: center;
  min-width: 58px;
  padding: 6px 9px;
}

.procurement-status-pill {
  align-items: center;
  background: #f1f5f9;
  border-radius: 999px;
  color: #475569;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1.2;
  max-width: 150px;
  min-width: 112px;
  padding: 8px 10px;
  text-align: center;
}

.procurement-status-pill--open {
  background: #fff7ed;
  color: #c2410c;
}

.procurement-status-pill--moving {
  background: #eff6ff;
  color: #1d4ed8;
}

.procurement-status-pill--pending {
  background: #fef3c7;
  color: #92400e;
}

.procurement-status-pill--done {
  background: #ecfdf5;
  color: #047857;
}

.procurement-status-pill--cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

.procurement-exec-name {
  color: #64748b;
  display: block;
  font-size: 11px;
  font-weight: 800;
}

.procurement-action-cell,
.procurement-vendor-cell,
.procurement-comment-cell {
  min-width: 120px;
}

.procurement-revamp .assign-driver-btn,
.procurement-revamp .track-ass-btn {
  align-items: center !important;
  background: var(--proc-action) !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  color: #ffffff !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 12px !important;
  font-weight: 600 !important;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  margin: 0 4px 0 0 !important;
  min-height: 32px !important;
  padding: 8px 12px !important;
  text-decoration: none !important;
  text-transform: none !important;
  transition: transform 0.16s ease, box-shadow 0.16s ease;
  white-space: nowrap !important;
}

.procurement-revamp .assign-driver-btn:hover,
.procurement-revamp .track-ass-btn:hover {
  background: var(--proc-action-dark) !important;
  box-shadow: none !important;
  transform: translateY(-1px);
}

.procurement-revamp .track-ass-btn {
  background: var(--proc-action-soft) !important;
  border: 1px solid #f6d9bb !important;
  color: var(--proc-action-dark) !important;
}

.procurement-revamp .track-ass-btn:hover {
  background: #fff7ed !important;
  color: var(--proc-action-dark) !important;
}

.procurement-revamp .assign-driver-btn[disabled],
.procurement-revamp .track-ass-btn[disabled] {
  background: #e2e8f0 !important;
  box-shadow: none !important;
  color: #94a3b8 !important;
  cursor: not-allowed;
}

.procurement-revamp .cancel-btn {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #f0cfcc !important;
  border-radius: 8px !important;
  color: #b91c1c !important;
  display: inline-flex;
  font-size: 12px !important;
  font-weight: 800;
  justify-content: center;
  line-height: 14px !important;
  margin: 0 !important;
  min-height: 32px;
  padding: 8px 12px !important;
  text-decoration: none !important;
}

.procurement-revamp .v-btn {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.procurement-vendor-cell > span {
  align-items: center;
  background: #eff6ff;
  border-radius: 999px;
  color: #1d4ed8;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  padding: 7px 10px;
}

.procurement-revamp .procurement-action-cell,
.procurement-revamp .procurement-vendor-cell,
.procurement-revamp .procurement-comment-cell {
  display: table-cell !important;
  text-align: left !important;
  vertical-align: middle !important;
}

.procurement-revamp .procurement-action-cell {
  white-space: nowrap;
}

.procurement-revamp .procurement-action-cell br {
  display: none;
}

.procurement-revamp .procurement-action-cell .assign-driver-btn,
.procurement-revamp .procurement-action-cell .track-ass-btn,
.procurement-revamp .procurement-action-cell .cancel-btn {
  display: flex !important;
  margin: 0 auto 8px !important;
  min-width: max-content;
  width: auto;
}

.procurement-revamp .procurement-action-cell .assign-driver-btn:last-child,
.procurement-revamp .procurement-action-cell .track-ass-btn:last-child,
.procurement-revamp .procurement-action-cell .cancel-btn:last-child {
  margin-bottom: 0 !important;
}

.procurement-revamp .procurement-vendor-cell .log {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.procurement-revamp .procurement-vendor-cell .track-ass-btn,
.procurement-revamp .procurement-vendor-cell .view-ass-btn,
.procurement-revamp .procurement-comment-cell .comment_btn,
.procurement-revamp .procurement-comment-cell .blue-button {
  align-items: center !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 5px 12px rgba(245, 130, 32, 0.2) !important;
  display: inline-flex !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  height: 32px !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  margin: 0 !important;
  min-width: 126px !important;
  padding: 8px 12px !important;
  text-transform: none !important;
  white-space: nowrap !important;
}

.procurement-revamp .procurement-vendor-cell .track-ass-btn,
.procurement-revamp .procurement-comment-cell .comment_btn,
.procurement-revamp .procurement-comment-cell .blue-button {
  background: var(--proc-primary) !important;
  color: #ffffff !important;
}

.procurement-revamp .procurement-vendor-cell .view-ass-btn {
  background: #eff6ff !important;
  color: #1d4ed8 !important;
}

.procurement-revamp .procurement-comment-cell > div:first-child {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  margin-bottom: 0;
}

.procurement-revamp .procurement-comment-cell .v-btn__content {
  color: #ffffff !important;
}

.procurement-revamp .procurement-comment-action {
  display: inline-flex;
  justify-content: center;
  margin-top: 0;
}

.procurement-comment-time {
  color: #64748b;
  display: block;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.25;
  margin-top: 5px;
  text-align: center;
  white-space: nowrap;
}

.procurement-comment-wrap {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.procurement-comment-text {
  color: #475569;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.procurement-comment-text--empty {
  color: #94a3b8;
  font-weight: 600;
}

.procurement-revamp .procurement-comment-action .comment_btn.blue-button {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: #667085 !important;
  display: inline-flex !important;
  height: 32px !important;
  justify-content: center !important;
  margin: 0 !important;
  min-width: 32px !important;
  padding: 0 !important;
  width: 32px !important;
}

.procurement-revamp .procurement-comment-action .comment_btn.blue-button:hover {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: var(--proc-primary-dark) !important;
}

.procurement-revamp
  .procurement-comment-action
  .comment_btn.blue-button
  .v-btn__content {
  align-items: center;
  color: inherit !important;
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 1;
}

.procurement-revamp
  .procurement-comment-action
  .comment_btn.blue-button
  .v-btn__content::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.procurement-revamp .v-alert {
  border-radius: 8px;
}

@media (max-width: 1260px) {
  .procurement-nav-grid {
    grid-template-columns: 1fr;
  }

  .procurement-nav-grid .procurement-status-tabs,
  .procurement-nav-grid .procurement-add-job-btn {
    justify-self: start;
  }

  .procurement-board-head {
    flex-direction: column;
  }

  .procurement-head-controls,
  .procurement-tab-stack {
    width: 100%;
  }

  .procurement-head-controls,
  .procurement-stats-grid,
  .procurement-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .procurement-revamp {
    padding: 0;
  }

  .procurement-nav-grid {
    padding: 16px;
  }

  .procurement-nav-grid .procurement-primary-tabs,
  .procurement-nav-grid .procurement-status-tabs {
    width: 100%;
  }

  .procurement-board-head,
  .procurement-stats-grid,
  .procurement-filter-grid,
  .procurement-head-controls {
    grid-template-columns: 1fr;
  }

  .procurement-board-head {
    padding: 22px 16px 14px;
  }

  .procurement-filter-panel,
  .procurement-table-card {
    margin-left: 16px;
    margin-right: 16px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .procurement-stats-grid {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.procurement-revamp--modern .procurement-board-head {
  align-items: center;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(170px, 0.24fr) minmax(0, 1fr);
  padding: 14px 24px;
}

.procurement-revamp--modern .procurement-title-area h1 {
  font-size: 22px;
  line-height: 1.15;
}

.procurement-revamp--modern .procurement-title-area span {
  font-size: 10.5px;
}

.procurement-revamp--modern .procurement-head-controls {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  max-width: none;
}

.procurement-revamp--modern .procurement-add-job-btn {
  align-self: center;
  flex: 0 0 auto;
  height: 36px !important;
  min-width: 136px;
  order: 2;
  padding: 0 12px !important;
}

.procurement-revamp--modern .procurement-filter-grid {
  align-items: flex-start;
  display: flex !important;
  flex-wrap: wrap;
}

.procurement-revamp--modern .procurement-filter-grid > .flex {
  flex: 1 1 190px !important;
  max-width: none !important;
  width: auto;
}

.procurement-revamp--modern
  .procurement-filter-grid
  > .procurement-filter-date {
  flex-basis: 230px !important;
}

.procurement-revamp--modern
  .procurement-filter-grid
  > .procurement-filter-actions {
  flex: 0 0 104px !important;
}

.procurement-revamp--modern .procurement-tab-stack {
  display: grid;
  flex: 1 1 auto;
  gap: 8px;
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
  min-width: 0;
  order: 1;
}

.procurement-revamp--modern .procurement-primary-tabs,
.procurement-revamp--modern .procurement-status-tabs {
  min-width: 0;
  overflow-x: auto !important;
  overflow-y: hidden !important;
}

.procurement-revamp--modern .procurement-primary-tabs .v-tabs__bar,
.procurement-revamp--modern .procurement-status-tabs .v-tabs__bar {
  min-height: 36px;
  padding: 4px;
}

.procurement-revamp--modern .procurement-primary-tabs .v-tabs__container,
.procurement-revamp--modern .procurement-status-tabs .v-tabs__container {
  min-height: 28px;
}

.procurement-revamp--modern .procurement-primary-tabs .v-tabs__item,
.procurement-revamp--modern .procurement-status-tabs .v-tabs__item {
  font-size: 12px;
  min-height: 28px;
  padding: 5px 10px;
}

.procurement-revamp--modern .procurement-table-card {
  overflow-x: visible;
}

.procurement-revamp--modern #jobsTable .v-table__overflow {
  max-width: 100%;
  overflow-x: auto;
}

.procurement-revamp--modern #jobsTable table.v-table {
  min-width: var(--oms-list-table-min-width, 116rem);
  table-layout: fixed;
}

.procurement-revamp--modern #jobsTable table.v-table tbody tr:hover {
  transform: none;
}

.procurement-revamp--modern #jobsTable table.v-table thead th,
.procurement-revamp--modern #jobsTable table.v-table tbody td {
  box-sizing: border-box;
}

.procurement-revamp--modern #jobsTable table.v-table thead th {
  overflow: visible;
}

/* oms-modern.css sizes list columns from --oms-list-col-*, falling back to
   `auto`, which shares the table evenly and left the Job ID column too narrow
   for a 10-digit id at the shared cell text size. Only column 1 is pinned; the
   rest keep sharing what is left. */
#nav .procurement-revamp--modern {
  --oms-list-col-1: 9%;
}

/* Row cards give their first cell a 3px accent border (oms-modern.css) where
   the header has a 1px border, so pad the Job ID header 2px more than the cell
   for its label to start exactly where the eye icon + ID below it start. */
#nav .procurement-revamp--modern #jobsTable table.v-table thead th:first-child {
  padding-left: calc(0.625rem + 2px) !important;
}

/* Vuetify renders the sort arrow (hidden until hover / sort) inline after the
   label, where it wrapped "Selling Price" onto a second line and made "Start
   Date" taller, lifting and dropping those labels off the header's text line.
   Out of the flow it still sits right after the label. */
#nav .procurement-revamp--modern #jobsTable table.v-table thead th.sortable .v-icon {
  font-size: 0.875rem !important;
  margin-left: 0.125rem;
  position: absolute;
}

.procurement-revamp--modern #jobsTable table.v-table tbody td {
  height: auto;
  min-height: 4.625rem;
  overflow: visible;
  overflow-wrap: break-word;
  vertical-align: middle !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(1),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(1) {
  min-width: 8.75rem !important;
  width: var(--oms-list-col-1, 9%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(2),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(2) {
  text-align: center !important;
  width: var(--oms-list-col-2, 5.5%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(3),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(3) {
  width: var(--oms-list-col-3, 12%);
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(4),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(4) {
  width: var(--oms-list-col-4, 6.5%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(5),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(5) {
  width: var(--oms-list-col-5, 16.5%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(6),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(6) {
  text-align: right !important;
  width: var(--oms-list-col-6, 8%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(7),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(7) {
  text-align: center !important;
  width: var(--oms-list-col-7, 8%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(8),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(8) {
  text-align: center !important;
  width: var(--oms-list-col-8, 9%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(9),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(9) {
  text-align: center !important;
  width: var(--oms-list-col-9, 9%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(10),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(10) {
  text-align: center !important;
  width: var(--oms-list-col-10, 6%) !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(11),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(11) {
  text-align: center !important;
  width: var(--oms-list-col-11, 9%) !important;
}

.procurement-revamp--modern .procurement-route-cell {
  word-break: normal !important;
}

.procurement-revamp--modern .procurement-job-cell {
  overflow: visible !important;
  white-space: nowrap !important;
}

.procurement-revamp--modern .procurement-job-id-row {
  align-items: center !important;
  display: inline-flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 0.375rem !important;
  justify-content: flex-start !important;
  max-width: 100%;
  min-height: 2rem !important;
  min-width: 0;
  width: 100%;
}

.procurement-revamp--modern .procurement-job-id-row > div {
  flex: 0 0 auto;
  padding-left: 0 !important;
}

.procurement-revamp--modern .procurement-job-id-row .v-icon {
  flex: 0 0 auto;
  font-size: 1.125rem !important;
  line-height: 1;
}

.procurement-revamp--modern .procurement-job-id {
  flex: 0 1 auto;
  font-size: 0.875rem;
  line-height: 1.2;
  min-width: 0;
  overflow: visible;
  white-space: nowrap;
}

.procurement-revamp--modern .procurement-action-cell,
.procurement-revamp--modern .procurement-vendor-cell,
.procurement-revamp--modern .procurement-comment-cell {
  line-height: 1.35;
  min-width: 0;
  white-space: normal;
}

.procurement-revamp--modern .procurement-job-id-row,
.procurement-revamp--modern .procurement-country-stack,
.procurement-revamp--modern .procurement-assignment-cell,
.procurement-revamp--modern .procurement-status-cell {
  justify-content: center;
  min-height: 48px;
}

.procurement-revamp--modern .procurement-company-cell {
  line-height: 1.35;
  white-space: normal;
}

.procurement-revamp--modern .procurement-date-cell,
.procurement-revamp--modern .procurement-price-cell {
  line-height: 1.3;
}

.procurement-revamp--modern .procurement-route-cell {
  line-height: 1.35;
  white-space: normal;
}

.procurement-revamp--modern .procurement-route-cell::before {
  display: none;
  transform: none;
}

.procurement-revamp--modern .procurement-route-cell--combined {
  min-width: 0 !important;
  padding-left: 0.5rem !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(1),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(1) {
  min-width: 0 !important;
}

.procurement-revamp--modern #jobsTable table.v-table th:nth-child(6),
.procurement-revamp--modern #jobsTable table.v-table td:nth-child(6),
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-price-cell {
  text-align: center !important;
}

.procurement-revamp--modern .procurement-job-cell,
.procurement-revamp--modern .procurement-country-cell,
.procurement-revamp--modern .procurement-price-cell {
  overflow: hidden !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}

.procurement-revamp--modern .procurement-job-cell {
  padding-left: 0.3125rem !important;
  padding-right: 0.3125rem !important;
}

.procurement-revamp--modern .procurement-job-id-row {
  gap: 0.1875rem !important;
  justify-content: center !important;
}

.procurement-revamp--modern .procurement-job-id-row > div,
.procurement-revamp--modern .procurement-job-id-row .v-btn,
.procurement-revamp--modern .procurement-job-id-row button {
  flex: 0 0 auto;
  height: 1.25rem !important;
  margin: 0 !important;
  min-width: 1.25rem !important;
  padding: 0 !important;
  width: 1.25rem !important;
}

.procurement-revamp--modern .procurement-job-id-row .v-icon {
  font-size: 0.875rem !important;
  height: 0.875rem !important;
  line-height: 0.875rem !important;
  width: 0.875rem !important;
}

.procurement-revamp--modern .procurement-job-id {
  flex: 0 1 auto;
  font-size: var(--proc-cell-text) !important;
  font-weight: 700;
  line-height: 1.1;
  min-width: 0;
  overflow: visible !important;
  text-overflow: clip;
  white-space: nowrap;
}

.procurement-revamp--modern .procurement-country-stack {
  align-items: center;
  gap: 0.125rem;
  justify-content: center;
  max-width: 100%;
  min-width: 0;
}

.procurement-revamp--modern .procurement-country-stack img {
  display: block;
  flex: 0 0 auto;
  height: 1.25rem !important;
  width: 1.75rem;
}

.procurement-revamp--modern .procurement-country-stack span {
  display: block;
  font-size: var(--proc-cell-text);
  font-weight: 600;
  line-height: 1.1;
  max-width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.procurement-revamp--modern .procurement-price-value {
  display: inline-block;
  font-size: var(--proc-cell-text);
  font-weight: 700;
  line-height: 1.15;
  max-width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.procurement-revamp--modern .procurement-route-pair {
  gap: 0.25rem;
}

.procurement-revamp--modern .procurement-route-point {
  padding-left: 0.875rem;
}

.procurement-revamp--modern .procurement-route-point strong {
  display: -webkit-box;
  font-size: var(--proc-cell-text);
  font-weight: 600;
  line-height: 1.2;
  max-height: 2.4em;
  overflow: hidden;
  overflow-wrap: normal;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.procurement-revamp--modern .procurement-action-cell {
  text-align: center !important;
}

.procurement-revamp--modern .procurement-action-cell .assign-driver-btn,
.procurement-revamp--modern .procurement-action-cell .track-ass-btn,
.procurement-revamp--modern .procurement-action-cell .cancel-btn {
  display: flex !important;
  margin: 3px auto !important;
}

.procurement-revamp--modern .procurement-vendor-cell .log,
.procurement-revamp--modern .procurement-comment-cell {
  align-items: center;
}

.procurement-revamp--modern .procurement-comment-cell {
  text-align: center !important;
}

.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-price-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-assignment-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-status-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-action-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-vendor-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-comment-cell {
  display: table-cell !important;
  vertical-align: middle !important;
}

.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-price-cell {
  text-align: center !important;
}

.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-assignment-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-status-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-action-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-vendor-cell,
.procurement-revamp--modern #jobsTable table.v-table tbody td.procurement-comment-cell {
  text-align: center !important;
}

.procurement-revamp--modern .procurement-assignment-cell br {
  display: none;
}

.procurement-revamp--modern .procurement-assignment-cell .procurement-assignment-count {
  font-size: var(--proc-cell-text);
  font-weight: 700;
  margin: 0 auto 6px;
}

.procurement-revamp--modern .procurement-assignment-cell > .log,
.procurement-revamp--modern .procurement-vendor-cell .log {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
}

.procurement-revamp--modern .procurement-vendor-cell .spacer {
  display: none !important;
}

.procurement-revamp--modern .procurement-vendor-cell .track-ass-btn.min_width_89 {
  box-shadow: 0 4px 10px rgba(245, 130, 32, 0.18) !important;
  font-size: 0.6875rem !important;
  line-height: 1.1 !important;
  margin: 0 auto !important;
  min-height: 1.875rem !important;
  min-width: 5.25rem !important;
  padding: 0.375rem 0.5rem !important;
  white-space: normal !important;
}

.procurement-revamp--modern .procurement-status-cell .procurement-status-pill,
.procurement-revamp--modern .procurement-status-cell .procurement-exec-name {
  margin-left: auto;
  margin-right: auto;
}

.procurement-revamp--modern .procurement-status-cell .procurement-status-pill {
  font-size: var(--proc-cell-label);
  font-weight: 700;
}

.procurement-revamp--modern .procurement-status-cell .procurement-exec-name {
  font-size: var(--proc-cell-text);
  font-weight: 500;
  margin-top: 6px;
  max-width: 150px;
  overflow-wrap: break-word;
  text-align: center;
}

.procurement-revamp--modern .procurement-action-cell .assign-driver-btn,
.procurement-revamp--modern .procurement-action-cell .track-ass-btn,
.procurement-revamp--modern .procurement-action-cell .cancel-btn,
.procurement-revamp--modern .procurement-assignment-cell .view-ass-btn,
.procurement-revamp--modern .procurement-vendor-cell .track-ass-btn,
.procurement-revamp--modern .procurement-vendor-cell .view-ass-btn,
.procurement-revamp--modern .procurement-comment-cell .comment_btn,
.procurement-revamp--modern .procurement-comment-cell .blue-button {
  margin-left: auto !important;
  margin-right: auto !important;
}

.procurement-revamp--modern .procurement-action-cell .assign-driver-btn,
.procurement-revamp--modern .procurement-action-cell .track-ass-btn,
.procurement-revamp--modern .procurement-action-cell .cancel-btn {
  display: flex !important;
  margin-bottom: 8px !important;
  min-width: max-content;
  width: auto;
}

.procurement-revamp--modern .procurement-action-cell .assign-driver-btn:last-child,
.procurement-revamp--modern .procurement-action-cell .track-ass-btn:last-child,
.procurement-revamp--modern .procurement-action-cell .cancel-btn:last-child {
  margin-bottom: 0 !important;
}

.procurement-revamp--modern .procurement-assignment-cell .view-ass-btn {
  align-items: center !important;
  background: #eff6ff !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 5px 12px rgba(37, 99, 235, 0.14) !important;
  color: #1d4ed8 !important;
  display: inline-flex !important;
  font-size: var(--proc-cell-label) !important;
  font-weight: 700 !important;
  height: 32px !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  min-width: 86px !important;
  padding: 8px 12px !important;
  text-transform: none !important;
  white-space: nowrap !important;
}

.procurement-revamp--modern .procurement-comment-cell > div {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

.procurement-revamp--modern .procurement-comment-cell > div:first-child {
  margin-bottom: 0;
}

#nav .procurement-revamp--modern .procurement-comment-cell {
  overflow: visible !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  position: relative;
  text-align: center !important;
}

#nav .procurement-revamp--modern .procurement-comment-cell .oms-comment-cell {
  gap: 0;
  justify-content: center;
  min-height: 2rem;
  position: relative;
  width: auto;
}

#nav .procurement-revamp--modern .procurement-comment-time {
  margin-left: auto;
  margin-right: auto;
}

#nav
  .procurement-revamp--modern
  .procurement-comment-cell
  .oms-comment-cell__text--empty {
  display: none !important;
}

#nav
  .procurement-revamp--modern
  .procurement-comment-cell
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
  background: var(--proc-panel);
  border: 1px solid var(--proc-border);
  border-radius: 8px;
  box-shadow: 0 0.75rem 1.75rem rgba(15, 23, 42, 0.16);
  color: var(--proc-ink);
  display: block !important;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.35;
  max-width: 18rem;
  min-width: 10rem;
  opacity: 0;
  padding: 0.5rem 0.625rem;
  pointer-events: none;
  position: absolute;
  right: calc(100% + 0.5rem);
  text-align: left;
  top: 50%;
  transform: translate(0.25rem, -50%);
  transition: opacity 0.15s ease, transform 0.15s ease;
  white-space: normal;
  z-index: 12;
}

#nav
  .procurement-revamp--modern
  .procurement-comment-cell:hover
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty),
#nav
  .procurement-revamp--modern
  .procurement-comment-cell:focus-within
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
  opacity: 1;
  pointer-events: auto;
  transform: translate(0, -50%);
}

@media (max-width: 1260px) {
  .procurement-revamp--modern .procurement-board-head {
    grid-template-columns: 1fr;
  }

  .procurement-revamp--modern .procurement-head-controls {
    align-items: flex-start;
    flex-direction: column;
  }

  .procurement-revamp--modern .procurement-add-job-btn {
    align-self: flex-start;
    order: 1;
  }

  .procurement-revamp--modern .procurement-tab-stack {
    grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
    order: 2;
    width: 100%;
  }
}

@media (max-width: 760px) {
  .procurement-revamp--modern .procurement-filter-grid > .flex,
  .procurement-revamp--modern
    .procurement-filter-grid
    > .procurement-filter-date,
  .procurement-revamp--modern
    .procurement-filter-grid
    > .procurement-filter-actions {
    flex: 1 1 100% !important;
  }

  .procurement-revamp--modern .procurement-board-head {
    padding: 18px 16px 12px !important;
  }

  .procurement-revamp--modern .procurement-tab-stack {
    grid-template-columns: 1fr;
  }

  .procurement-revamp--modern .procurement-primary-tabs .v-tabs__bar,
  .procurement-revamp--modern .procurement-status-tabs .v-tabs__bar {
    overflow-x: auto;
  }

  .procurement-revamp--modern .procurement-table-card {
    margin-left: 12px;
    margin-right: 12px;
    max-width: none;
  }

  .procurement-revamp--modern #jobsTable .v-table__overflow {
    border-radius: 8px;
    -webkit-overflow-scrolling: touch;
  }

  .procurement-revamp--modern #jobsTable table.v-table {
    min-width: var(--oms-list-table-min-width, 116rem);
  }

  .procurement-revamp--modern #jobsTable table.v-table thead th,
  .procurement-revamp--modern #jobsTable table.v-table tbody td {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .procurement-revamp .procurement-action-cell .assign-driver-btn,
  .procurement-revamp .procurement-action-cell .track-ass-btn,
  .procurement-revamp .procurement-action-cell .cancel-btn,
  .procurement-revamp .procurement-vendor-cell .track-ass-btn,
  .procurement-revamp .procurement-vendor-cell .view-ass-btn,
  .procurement-revamp .procurement-comment-cell .comment_btn,
  .procurement-revamp .procurement-comment-cell .blue-button {
    min-width: 118px !important;
    width: 100%;
  }

  .procurement-revamp .procurement-vendor-cell .track-ass-btn.min_width_89 {
    min-width: 5.25rem !important;
    width: auto !important;
  }
}
</style>

<style scoped>
.viewDetail {
  cursor: pointer;
}
.job-detail {
  margin: auto 0;
}
.theme--light.menuable__content__active {
  min-width: 290px !important;
}
.text-center {
  text-align: center !important;
}

.date-picker {
  min-width: 100%;
}

.page-count-span {
  float: right;
  margin-top: 26px;
  color: #ea7a1c;
}

.cancel-btn {
  text-decoration: none;
  color: #ffffff;
  border: 2px solid red;
  padding: 2px;
  margin-top: 5px;
  background-color: #f38282;
  border-radius: 5px;
}
.view-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #c87ffe;
  border: 2px solid indigo;
  padding: 2px 5px;
  border-radius: 5px;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
  width: max-content !important;
}
.tooltip-op-comment {
  /* left: calc(100% - 20.2%) !important; */
  max-width: 15%;
  opacity: 1 !important;
}
.p-16 {
  padding: 0 16px !important;
}
.p-b-0 {
  padding-bottom: 0 !important;
}
.p-t-0 {
  padding-top: 0 !important;
}
.minHeight {
  min-height: 300px;
}
.colorchange {
  background-color: #fae3e3 !important;
}
.colorchangeyellow {
  background-color: #ffffe0 !important;
}
.spacerclass {
  max-height: 550px !important;
}
.m-t-10 {
  margin-top: 10px;
}

.filter {
  padding: 20px;
  margin: 0 auto;
}
.reset {
  margin-top: 10px;
}
</style>
